@import '../../global/style/utilities/globals';
@import '../../global/style/nano-theme/form';
@import '../../global/style/nano-theme/layers';
@import '../form-control/form-control';
@import '../form-control/form-control-vars';

:host {
  @include formControlVars;

  position: relative;
  width: 100%;
  padding: 0 !important;
  font-family: $font-family-base;
  display: block;
}

:host(.nano-color) {
  --input-border-style--focus: #{$input-border-style} var(--nano-color-tint, #{nano-color(primary, tint)});
  --multi-input-value-bg: var(--nano-color-tint-rgb);
  --multi-input-value-border: var(--nano-color-shade);
  --multi-input-value-text-color: var(--nano-color-contrast);

  color: current-color(base);
}

:host-context(nano-item:not(.item-label)) {
  --padding-start: 0;
}

:host([disabled]:not([disabled='false'])) {
  * {
    pointer-events: none !important;
  }
}

select {
  display: none;
}

.select__native-input {
  @include text-inherit();

  padding: unset;
  padding-inline: var(--padding-start) var(--padding-end);
  padding-block: 0;
  border-radius: var(--input-border-radius);
  text-overflow: ellipsis;
  color: var(--input-text-color);
  display: inline-block;
  flex: 1;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  border: 0;
  outline: none;
  background: transparent;
  appearance: none;
  margin: 0;
  box-sizing: border-box;
  resize: none;
  overflow: hidden;
  cursor: default;
  line-height: 2.5em;

  .has-float-label & {
    line-height: 2.1em;
    min-height: 2.1em;
    padding-block-start: 1.4em;
  }

  &::selection {
    background: transparent;
  }

  &::-moz-selection {
    background: transparent;
  }

  &::placeholder {
    color: var(--placeholder-color);
    font-family: inherit;
    font-style: var(--placeholder-font-style);
    font-weight: var(--placeholder-font-weight);
    opacity: var(--placeholder-opacity);
    line-height: inherit;
    min-height: initial;
  }

  &::-moz-placeholder {
    line-height: 2.8em;
    text-overflow: ellipsis;
  }

  &:-webkit-autofill {
    background-color: transparent;
  }

  &::-webkit-search-decoration,
  &::-webkit-search-cancel-button,
  &::-webkit-search-results-button,
  &::-webkit-search-results-decoration {
    appearance: none;
  }

  &:invalid {
    box-shadow: none;
  }

  &::-ms-clear,
  &::-ms-reveal {
    display: none;
  }

  &.resizable {
    resize: vertical;
    overflow: auto;
  }

  .form-ctrl__textarea & {
    line-height: 1.5em;
    padding-block: var(--padding-top) var(--padding-bottom);
    white-space: pre-wrap;

    &::placeholder {
      line-height: 1.5em;
    }
  }

  .has-float-label.textarea & {
    padding-block-start: 1.8em;
  }

  :host(.masked) & {
    opacity: 0;
    position: absolute;
    inset-inline-start: 0;
    inset-block-start: 0;
  }
}

.select__mask {
  @include text-inherit();

  padding-inline: var(--padding-start) var(--padding-end);
  padding-block: 0;
  border-radius: var(--input-border-radius);
  pointer-events: none;
  line-height: 2.5em;
  min-height: 2.5em;
}

// multi stuff

.select__multi {
  &-wrap {
    padding-block: 0 var(--padding-bottom);
    padding-inline: 0 0;
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    overflow: hidden;
    align-items: flex-start;

    :host(.has-float-label) & {
      padding-block-start: 1em;
    }
  }

  &-input {
    @include text-inherit();

    padding-inline: var(--padding-start) var(--padding-end);
    padding-block: var(--padding-bottom) 0;
    min-width: 50px;
    width: 100%;
    max-height: 100%;
    appearance: none;
    border: 0;
    outline: none;
    display: inline-block;
    background: transparent;
    flex: 0;
    position: relative;
    box-sizing: border-box;
    line-height: calc(2.5em - var(--padding-bottom));
    height: calc(2.5em - var(--padding-bottom));

    &:last-child {
      flex: 1;
    }
  }

  &-value {
    margin-block: var(--padding-bottom) 0;
    margin-inline: var(--padding-start) -3px;
    background: rgba(var(--multi-input-value-bg), 0.8);
    color: var(--multi-input-value-text-color);
    border: 1px solid;
    border-color: var(--multi-input-value-border);
    padding: 0.35em 0.5em;
    max-width: 100%;
    display: flex;
    align-items: center;
    font-size: var(--input-font-size);
    letter-spacing: 1px;
    max-height: calc(2.5em - 8px);

    span {
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 100%;
      overflow: hidden;
      line-height: 1;
    }
  }

  &-value-remove {
    @include background-position(center);

    padding-inline-start: 0.5em;
    margin: 0;
    color: inherit;
    border: 0;
    outline: none;
    background-color: transparent;
    background-repeat: no-repeat;
    appearance: none;
    display: flex;
    align-items: center;
    inset-block-start: 0;
    font-size: 1em;

    nano-icon {
      --color: var(--multi-input-value-text-color);
    }
  }
}

.form-ctrl__float-label {
  width: calc(100% - (1em + (var(--padding-start) * 2)));

  :host(.has-focus.has-multiple) & {
    transform: translateY(-110%);
    font-size: 0.8em;
  }

  :host(.has-value.has-multiple) & {
    transform: translateY(21%);
    inset-block-start: 0;
  }
}

:host(.has-focus) select,
:host(.has-focus) a,
:host(.has-focus) button {
  pointer-events: auto;
}
